/**
 * Turns a feature name of the format `${PACKAGE_NAMESPACE}_${FEATURE_NUMBER}_${FEATURE_NAME} into
 * its unique component parts, disregarding the human readable feature name.
 *
 * For example, for the feature name `COR_004_FOO_BAR`, will be returned as
 * `{packageName: 'COR', featureNumber: 4}`.
 */
import { __read } from "tslib";
import { COR } from '../Constants/PackageNamespace';
var extractMessageParamsFromFeatureName = function (featureName) {
    if (featureName === '_')
        return { packageNamespace: COR, featureNumber: 0 };
    var _a = __read(featureName.split('_'), 2), packageNamespace = _a[0], featureNumber = _a[1];
    return { packageNamespace: packageNamespace, featureNumber: Number(featureNumber) };
};
export { extractMessageParamsFromFeatureName };
//# sourceMappingURL=extractMessageParamsFromFeatureName.js.map